import moment from 'moment';

import { Logger } from '../../../generic/utils';
import { wrapperIdentifier } from '../common';
import { TRANSPORTS } from './transportDefinitions';

const console = new Logger(wrapperIdentifier);

if (console) {
  //Just for usage
}

var inited = false;

export const FacebookPixel = {
  initialize: async function (
    getInstanceApi: any,
    user: any,
    loadSessionUser: any,
    { debugEnabled }: { debugEnabled?: boolean }
  ) {
    if (!user) {
      inited = false;
      return
    }
    if (!inited) {
      debugEnabled && console.log(`## 📣 ${TRANSPORTS.FACEBOOK_PIXEL} INITING`);
      inited = true;

      let analyticId = user?.metadata?.analytics?.FACEBOOK_PIXEL?.id;

      // SI NO TIENE LA ANALYTIC CREADA SE CREA
      if (!analyticId) {
        try {
          analyticId = await this.startAnalytic({
            getInstanceApi,
            user,
            debugEnabled,
          });
          if (analyticId) {
            await loadSessionUser()
          }
        } catch (error) {
          throw error;
        }
      }
      console.log(`## ✅ ${TRANSPORTS.FACEBOOK_PIXEL} analyticId`, analyticId);

      // SE AÑADEN LOS SCRIPTS
      try {
        const addedScripts = await this.addScripts({
          getInstanceApi,
          debugEnabled,
          analyticId,
        });
        if (addedScripts) {
          debugEnabled &&
            console.log(
              `## ✅ ${TRANSPORTS.FACEBOOK_PIXEL} addedScripts`,
              addedScripts
            );
        }
      } catch (error) {
        throw error;
      }
    }
  },
  startAnalytic: async function (args: { [k: string]: any }) {
    const { getInstanceApi, user, debugEnabled } = args;

    debugEnabled &&
      console.log(`## 📣 CREATE NEW ${TRANSPORTS.FACEBOOK_PIXEL} ANALYTICS`);

    try {
      const apiInstance = getInstanceApi();

      const transports = await apiInstance.microserviceCall('Analytics')(
        '/transports',
        'GET',
        {
          filter: { where: { identifier: TRANSPORTS.FACEBOOK_PIXEL } },
        }
      );

      if (transports.length === 0) {
        throw new Error('FACEBOOK_PIXEL is not actived');
      }

      const analyticsCreated = await apiInstance.microserviceCall('Analytics')(
        `/users/${user.id}/anltcs`,
        'POST',
        {
          transportId: transports[0].id,
          input: {},
        }
      );

      debugEnabled &&
        console.log(
          ` ${TRANSPORTS.FACEBOOK_PIXEL} analyticsCreated`,
          analyticsCreated
        );

      let analyticPooled: any = {};
      let status = analyticsCreated.status;
      let finishDate = moment()
        .add(20, 'seconds')
        .toDate();
      while (
        (status !== 'CREATED_SUCCESS' && status !== 'CREATED_ERROR') ||
        +new Date() > +finishDate
      ) {
        await new Promise(r => setTimeout(r, 1000));
        analyticPooled = await apiInstance.microserviceCall('Analytics')(
          `/anltcs/${analyticsCreated.id}`,
          'GET'
        );
        status = analyticPooled.status;
      }

      if (status === 'CREATED_ERROR') {
        debugEnabled &&
          console.log(
            `## ❌ ${TRANSPORTS.FACEBOOK_PIXEL} startAnalytic analyticPooled`,
            analyticPooled
          );
        throw new Error('Error creating analytic');
      } else if (status !== 'CREATED_SUCCESS') {
        debugEnabled &&
          console.log(
            `## ❌ ${TRANSPORTS.FACEBOOK_PIXEL} startAnalytic analyticPooled`,
            analyticPooled
          );
        throw new Error('Timeout reached creating analytic');
      }
      // debugEnabled &&
      //   console.log(
      //     `## ✅ ${TRANSPORTS.FACEBOOK_PIXEL} startAnalytic analyticPooled`,
      //     analyticPooled
      //   );

      return analyticsCreated.id;
    } catch (error) {
      debugEnabled && console.log('## ❌ error', error);
      throw error;
    }
  },
  addScripts: async function (args: { [k: string]: any }) {
    const { debugEnabled } = args;

    try {
      const scripts = await this.getScripts(args);
      debugEnabled &&
        console.log(`## 🧩 ${TRANSPORTS.FACEBOOK_PIXEL} scripts`, scripts);

      const script = this.createScript(scripts.script);
      const noScript = this.createNoScript(scripts.noScript);

      document.head.prepend(noScript);
      document.head.prepend(script);

      return true;
    } catch (error) {
      debugEnabled && console.log('## ❌ error', error);
      throw error;
    }
  },
  getScripts: async function (args: { [k: string]: any }) {
    const { getInstanceApi, debugEnabled, analyticId } = args;
    debugEnabled &&
      console.log(`## 🧩 ${TRANSPORTS.FACEBOOK_PIXEL} GET SCRIPTS`);

    try {
      const apiInstance = getInstanceApi();

      const eventDefinitions = await apiInstance.microserviceCall('Analytics')(
        '/event-definitions',
        'GET',
        {
          filter: {
            where: {
              identifier: `${TRANSPORTS.FACEBOOK_PIXEL}_GENERATE_SCRIPTS`,
              transportIdentifier: TRANSPORTS.FACEBOOK_PIXEL,
            },
          },
        }
      );

      if (eventDefinitions.length === 0) {
        throw new Error('GENERATE_SCRIPTS for FACEBOOK_PIXEL is not actived');
      }

      const eventCreated = await apiInstance.microserviceCall('Analytics')(
        `/anltcs/${analyticId}/events`,
        'POST',
        {
          eventDefinitionId: eventDefinitions[0].id,
          input: {},
        }
      );
      debugEnabled &&
        console.log(
          `## ${TRANSPORTS.FACEBOOK_PIXEL} eventCreated`,
          eventCreated
        );

      let eventPooled: any = {};
      let status = eventCreated.status;
      let finishDate = moment()
        .add(20, 'seconds')
        .toDate();
      while (
        (status !== 'FINISHED_SUCCESS' && status !== 'FINISHED_ERROR') ||
        +new Date() > +finishDate
      ) {
        await new Promise(r => setTimeout(r, 1000));
        eventPooled = await apiInstance.microserviceCall('Analytics')(
          `/events/${eventCreated.id}`,
          'GET'
        );
        debugEnabled &&
          console.log(
            `## ${TRANSPORTS.FACEBOOK_PIXEL} eventPooled`,
            eventPooled
          );
        status = eventPooled.status;
      }

      if (status === 'FINISHED_ERROR') {
        debugEnabled &&
          console.log(
            `## ❌ ${TRANSPORTS.FACEBOOK_PIXEL} getScripts eventPooled`,
            eventPooled
          );
        throw new Error('Error creating event');
      } else if (status !== 'FINISHED_SUCCESS') {
        debugEnabled &&
          console.log(
            `## ❌ ${TRANSPORTS.FACEBOOK_PIXEL} getScripts eventPooled`,
            eventPooled
          );
        throw new Error('Timeout reached creating event');
      }
      // debugEnabled &&
      //   console.log(
      //     `## ✅ ${TRANSPORTS.FACEBOOK_PIXEL} getScripts eventPooled`,
      //     eventPooled
      //   );

      return { ...eventPooled.output };
    } catch (error) {
      debugEnabled && console.log('## ❌ error', error);
      throw error;
    }
  },
  createScript: function (data: string) {
    const script = document.createElement('script');
    script.innerHTML = data;
    return script;
  },
  createNoScript: function (data: string) {
    const noscript = document.createElement('noscript');
    noscript.innerHTML = data;
    return noscript;
  },
};
